import React, { useEffect, useState } from "react";
import { ClinicalTrials } from "../../containers/ClinicalTrials/ClinicalTrials";
import { useAuthProtocol } from "../../components/Authorization/useAuthorization";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "react-bootstrap";
import { TeamView } from "../Team/TeamView";
import HospitalFiles from "../../containers/ClinicalTrials/HospitalFiles/HospitalFiles";
import { Regulatory } from "../../containers/ClinicalTrials/Regulatory/Regulatory";
import Devices from "../../containers/ClinicalTrials/Devices/Devices";

export const ClinicalTrialsView = (props) => {
  const {
    match: { params },
  } = props;

  const {
    match: {
      params: { protocolId, section },
    },
  } = props;
  const { t } = useTranslation();
  const [isAuthorized] = useAuthProtocol(protocolId);
  const [selectedTab, setSelectedTab] = useState(section ?? "clinical-trials");

  useEffect(() => {
    setSelectedTab(section);
  }, [section]);

  const handleChangeTab = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <Tabs
      activeKey={selectedTab}
      onSelect={handleChangeTab}
      id="general-id"
      mountOnEnter={true}
      unmountOnExit={true}
    >
      <Tab
        eventKey={"clinical-trials"}
        title={t("clinicalTrials.menu.clinicalTrials")}
      >
        <ClinicalTrials {...props} expandedAll={true} />
      </Tab>
      <Tab eventKey={"team"} title={t("clinicalTrials.menu.team")}>
        <TeamView {...props} expandedAll={true} />
      </Tab>
      <Tab
        eventKey={"hospital-files"}
        title={t("clinicalTrials.menu.hospitalFiles")}
      >
        <HospitalFiles {...props} expandedAll={true} />
      </Tab>
      <Tab eventKey={"regulatory"} title={t("clinicalTrials.menu.regulatory")}>
        <Regulatory {...props} expandedAll={true} />
      </Tab>
      <Tab eventKey={"devices"} title={t("clinicalTrials.menu.devices")}>
        <Devices {...props} expandedAll={true} />
      </Tab>
    </Tabs>
  );
};
